import { generateUUID } from 'shared/helpers/utils/generate-uuid';
import { TableFilterFieldType } from 'common/TableFilter';
import type { TableFilterField } from 'common/TableFilter';

export const organizationsFilterFields: TableFilterField[] = [
  {
    key: generateUUID(),
    name: 'name',
    label: 'Название организации',
    type: TableFilterFieldType.INPUT,
  },
  {
    key: generateUUID(),
    name: 'municipalityId',
    label: 'Муниципалитет',
    type: TableFilterFieldType.SELECT,
    options: [],
    isLoadableOptions: true,
  },
];
